import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table";
import * as R from "ramda"
import { selectListItems } from "../../../../../redux/library/selector";
import { selectAggregationPolicyListItems } from "../../../../../redux/aggregation-policies/selector";
import { aggregationPolicy } from "../../../../../redux/aggregation-policies/action";

const AggregationPolicies = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const libraryData = useSelector(selectListItems)
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);

    const itemsData = useSelector(selectAggregationPolicyListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'IsActive', headerName: 'Active', cellRenderer: 'yesNoRenderer', filter: false },
          { field: 'Name', headerName: 'Name' , searchField: 'Name', filter: true },
      { field: 'StartDateUtc', headerName: 'Start Date', isDateValueFormat:true, filter: false },
      { field: 'EndDateUtc', headerName: 'End Date', isDateValueFormat:true, filter: false },
      
        ]);
      }

      const getEntityName = (MarketplaceTypeId: any) => {
        const EntityNameList = R.find(
          (storeName: any) => parseInt(
            storeName.Value,
            10
          ) === parseInt(
            MarketplaceTypeId,
            10
          ),
          libraryData?.result?.EntityTypes
        )
        return EntityNameList ? EntityNameList.Description : ''
      }
    
      const handleSearch = (data: any) => {
        console.log('Search data', data)
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        dispatch(aggregationPolicy.list({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/market-place-policy/aggregation-policies/list`,
          entity: 'aggregationPolicy',
          jsonData: {  "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          "Searches": searchCriteria,}
      }));
      }
      const filterTypes = [{
        name: 'Text', value: "text"
      },
      {
        name: 'Number', value: "number"
      },
      {
        name: 'CheckBox', value: "checkbox"
      },
      {
        name: 'Date', value: "date"
      }
      ]
      const handleReloadData = () => {
        fetchAggregationPolicy();
      }
      const handleAdd=()=>{
        navigate(`${0}`)
      }
      const handleEdit=(data: any)=>{
        
        navigate(`${data?.Id}`)
      }
      
      const handleDelete=(data: any)=>{
        dispatch(aggregationPolicy.delete({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/market-place-policy/aggregation-policies/delete`,
          entity: 'aggregationPolicy',
          jsonData: {
              Records: [
                  {
                      Id: data?.Id
                  }
              ]
          }
      })).then(() => {
          dispatch(aggregationPolicy.list({
              url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/market-place-policy/aggregation-policies/list`,
              entity: 'aggregationPolicy',
              jsonData: { "PageNumber": pageData,
              "PageSize": 10,
              "SortField": "Id",
              "SortOrder": "desc",}
          }));
      });
      }
      const additionButtons: any = [
        {
          svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
            <title>Add Aggregation Policy</title>
            <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
          </svg>,
          // name: 'Add Aggregation Policy',
          callback: () => handleAdd(),
        },
        {
          svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
            <title>Reload</title>
            <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>,
          // name: 'Reload',
          callback: () => handleReloadData(),
        },
      ];
      const fetchAggregationPolicy=()=>{
        dispatch(aggregationPolicy.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/market-place-policy/aggregation-policies/list`,entity:'marketPlacePolicy',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }
	useEffect(() => {
        createColumnDefs()
        fetchAggregationPolicy()
	}, [pageData,pageSize])

	return (
    <>
    {itemsData?.isLoading ? <PageLoader />
 : 
		<Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
    paginationData={itemsData?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} filterTypeLists={filterTypes}  onSearch={handleSearch}
    enableFilter={true}additionButtons={additionButtons} headingName="Aggregation Policies"/>
     
  }
  </>
	);
};

export default AggregationPolicies;


